import { render, staticRenderFns } from "./DirectChatDetails.vue?vue&type=template&id=7b3c89d2&"
import script from "./DirectChatDetails.vue?vue&type=script&lang=js&"
export * from "./DirectChatDetails.vue?vue&type=script&lang=js&"
import style0 from "./DirectChatDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports